var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _dec6, _dec7, _class2, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";

/** Note these shouldn't be Traits as they are used in `@anyTrait FeatureInfoTemplateTraits.formats` */

export let FeatureInfoTemplateTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Name template",
  description: "A mustache template string for formatting name"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Template",
  description: "A Mustache template string for formatting description",
  isNullable: false
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Show feature info download",
  description: "Show feature info download **if** a `template` has been provided. If no `template` is provided, then download will always show.",
  isNullable: false
}), _dec4 = anyTrait({
  name: "Partials",
  description: "An object, mapping partial names to a template string. Defines the partials used in Template."
}), _dec5 = anyTrait({
  name: "Formats",
  description: "An object, mapping field names to formatting options."
}), _class = class FeatureInfoTemplateTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "template", _descriptor2, this);
    _initializerDefineProperty(this, "showFeatureInfoDownloadWithTemplate", _descriptor3, this);
    _initializerDefineProperty(this, "partials", _descriptor4, this);
    _initializerDefineProperty(this, "formats", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "template", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showFeatureInfoDownloadWithTemplate", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "partials", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "formats", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

/** Note: MappableTraits has the following:
 * - featureInfoTemplate
 * - showStringIfPropertyValueIsNull
 *
 * FeatureInfoUrlTemplateTraits is used by FeatureInfoUrlTemplateMixin
 */
let FeatureInfoUrlTemplateTraits = (_dec6 = primitiveTrait({
  type: "string",
  name: "Feature Info Url template",
  description: "A template URL string for fetching feature info. Template values of the form {x} will be replaced with corresponding property values from the picked feature."
}), _dec7 = primitiveTrait({
  type: "number",
  name: "Max feature request",
  description: "Max number of feature info requests to send to API url. Keep this number small to avoid sending to many requests to server (default 10)."
}), _class2 = class FeatureInfoUrlTemplateTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "featureInfoUrlTemplate", _descriptor6, this);
    _initializerDefineProperty(this, "maxRequests", _descriptor7, this);
  }
}, _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "featureInfoUrlTemplate", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "maxRequests", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _class2);
export { FeatureInfoUrlTemplateTraits as default };